import React from 'react';
import ResultTable from '../../UI/DataTable/DataTable';

const mdmSearchResult = (props) => {

    // Search Results mapping
    const resultColumnMapping = [
        {dataField: 'firstName', text: 'First Name'},
        {dataField: 'lastName', text: 'Last Name'},
        {dataField: 'suffix', text: 'Suffix'},
        {dataField: 'zip', text: 'Zip Code'},
        {dataField: 'dob', text: 'DOB'}
    ];

    let searchResult = null;
    if(props.searchResult && props.searchResult.length > 0) {
        searchResult =
        <>
            <ResultTable
                greyArea = {props.isGreyingEnabled}
                title="MDM Search Results"
                data={props.searchResult}
                columns={resultColumnMapping}
                clicked={props.selected}
            />
        </>
    }
    return searchResult;
}

export default mdmSearchResult;